import { render, staticRenderFns } from "./TransactionsPurchasesTable.vue?vue&type=template&id=95f88d7a"
import script from "./TransactionsPurchasesTable.vue?vue&type=script&lang=js"
export * from "./TransactionsPurchasesTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionsPurchasesTable.vue?vue&type=style&index=0&id=95f88d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports